import { render, staticRenderFns } from "./platform-menu-builder.vue?vue&type=template&id=52998ef6"
import script from "./platform-menu-builder.vue?vue&type=script&lang=js"
export * from "./platform-menu-builder.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports